export default __webpack_public_path__ + "static/media/B_Adhesive_Screeds.c34fa526.jpg";